 class S12wdProductQuickaddSection extends HTMLElement {
    connectedCallback() {
        this.onAddClick = this.onAddClick.bind(this);
        this.addEventListener('click', this.onAddClick);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.onAddClick);
    }

    onAddClick(event) {
        const addButton = event.target.closest('.s1-2wd-product-quickadd-item-add');
        if (!addButton || !this.contains(addButton)) return;

        const item = addButton.closest('.s1-2wd-product-quickadd-item');
        const variantId = item?.dataset.variantId;
        if (!variantId) return;

        this.addToCart(variantId, addButton);
    }

    addToCart(variantId, button) {
        if (button.classList.contains('is-loading')) return;
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');

        const cart =
            document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
            method: 'POST',
            headers: {
                Accept: 'application/json'
            }
        };

        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('id', String(variantId).trim());
        formData.append('quantity', '1');

        if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append(
                'sections',
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') {
                cart.setActiveElement(button);
            }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 's1-2wd-product-quickadd',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message
                        });
                    }
                    console.error(response.description || response.message || 'Add to cart failed');
                    return;
                } else if (!cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 's1-2wd-product-quickadd',
                        productVariantId: formData.get('id'),
                        cartData: response
                    });
                }

                if (cart && typeof cart.renderContents === 'function') {
                    cart.renderContents(response);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                button.classList.remove('is-loading');
                button.removeAttribute('aria-disabled');
                if (cart && cart.classList.contains('is-empty')) {
                    cart.classList.remove('is-empty');
                }
            });
    }
}

if (!customElements.get('s1-2wd-product-quickadd-section')) {
    customElements.define('s1-2wd-product-quickadd-section', S12wdProductQuickaddSection);
}
